import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'beyond-util';
@Injectable()
export class RtsAuthService {
  constructor(
    private router: Router,
    public utilAuthService: AuthenticationService
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/services/rtsAuth.service.ts